import { render, staticRenderFns } from "./CFFileRedirect.vue?vue&type=template&id=59818f50&"
import script from "./CFFileRedirect.vue?vue&type=script&lang=ts&"
export * from "./CFFileRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports